import type { Product } from "@lib/product/types";
import { useGetHeaders } from "@hooks/useGetHeaders";
import { AnalyticsClient } from "@lib/analytics/AnalyticsClient";
import { TryAndBuy as TryAndBuyMC } from "@lib/constants/contentful/try-and-buy";
import { useState } from "react";

export const useTryAndBuyModal = (product: Product) => {
    const [isOpen, setIsOpen] = useState(false);

    const { label } = useGetHeaders({
        microcopiesWithTitles: {
            label: TryAndBuyMC.label,
        },
    });

    const onOpen = () => {
        AnalyticsClient.tryAndBuyInitiated({
            productId: product.id,
            productName: product.name,
        });
        setIsOpen(true);
    };
    const onClose = () => setIsOpen(false);

    return {
        onOpen,
        isOpen,
        onClose,
        label,
    };
};
